export default "__VITE_PUBLIC_ASSET__9cdd4839__"